export default "__VITE_PUBLIC_ASSET__e43a842a__"